import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, SearchIcon, FilterIcon, TrashIcon, PencilIcon, EyeIcon } from 'lucide-react';
import { useProducts } from '../../context/ProductContext';
export const ProductManagement: React.FC = () => {
  const {
    products
  } = useProducts();
  return <div className="container mx-auto px-4 py-8" data-id="element-826">
      <div className="flex justify-between items-center mb-6" data-id="element-827">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-828">
          Product Management
        </h1>
        <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-md flex items-center" data-id="element-829">
          <PlusIcon size={18} className="mr-1" data-id="element-830" />
          Add Product
        </button>
      </div>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden" data-id="element-831">
        <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-832">
          <div className="relative flex-grow max-w-md" data-id="element-833">
            <input type="text" placeholder="Search products..." className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500" data-id="element-834" />
            <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 dark:text-gray-400" data-id="element-835" />
          </div>
          <div className="flex items-center space-x-2" data-id="element-836">
            <button className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 flex items-center" data-id="element-837">
              <FilterIcon size={18} className="mr-1" data-id="element-838" />
              Filter
            </button>
            <select className="border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-500" data-id="element-839">
              <option value="all" data-id="element-840">All Categories</option>
              <option value="electronics" data-id="element-841">Electronics</option>
              <option value="gold" data-id="element-842">Gold</option>
              <option value="silver" data-id="element-843">Silver</option>
              <option value="platinum" data-id="element-844">Platinum</option>
              <option value="technical-tools" data-id="element-845">Technical Tools</option>
            </select>
            <select className="border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-500" data-id="element-846">
              <option value="newest" data-id="element-847">Newest First</option>
              <option value="oldest" data-id="element-848">Oldest First</option>
              <option value="price-high" data-id="element-849">Price: High to Low</option>
              <option value="price-low" data-id="element-850">Price: Low to High</option>
            </select>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-851">
          <table className="w-full" data-id="element-852">
            <thead className="bg-gray-50 dark:bg-gray-900" data-id="element-853">
              <tr data-id="element-854">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-855">
                  Product
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-856">
                  Category
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-857">
                  Price
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-858">
                  Stock
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-859">
                  Featured
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-860">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-700" data-id="element-861">
              {products.map(product => <tr key={product.id} data-id="element-862">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-863">
                    <div className="flex items-center" data-id="element-864">
                      <div className="h-10 w-10 flex-shrink-0 rounded overflow-hidden" data-id="element-865">
                        <img src={product.image} alt={product.name} className="h-full w-full object-cover" data-id="element-866" />
                      </div>
                      <div className="ml-4" data-id="element-867">
                        <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-868">
                          {product.name}
                        </div>
                        <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-869">
                          ID: {product.id}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-870">
                    <span className="px-2 py-1 text-xs font-semibold rounded-full bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300" data-id="element-871">
                      {product.category.charAt(0).toUpperCase() + product.category.slice(1)}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-872">
                    ${product.price.toLocaleString()}
                    {product.originalPrice && <span className="ml-2 text-xs text-gray-500 dark:text-gray-400 line-through" data-id="element-873">
                        ${product.originalPrice.toLocaleString()}
                      </span>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-874">
                    {product.inStock ? <span className="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300" data-id="element-875">
                        In Stock
                      </span> : <span className="px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300" data-id="element-876">
                        Out of Stock
                      </span>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-877">
                    {product.featured ? <span className="px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300" data-id="element-878">
                        Featured
                      </span> : <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-879">
                        -
                      </span>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm" data-id="element-880">
                    <div className="flex justify-end space-x-2" data-id="element-881">
                      <button className="p-1 text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300" data-id="element-882">
                        <EyeIcon size={18} data-id="element-883" />
                      </button>
                      <button className="p-1 text-yellow-600 dark:text-yellow-400 hover:text-yellow-800 dark:hover:text-yellow-300" data-id="element-884">
                        <PencilIcon size={18} data-id="element-885" />
                      </button>
                      <button className="p-1 text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300" data-id="element-886">
                        <TrashIcon size={18} data-id="element-887" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex justify-between items-center" data-id="element-888">
          <div className="text-sm text-gray-700 dark:text-gray-300" data-id="element-889">
            Showing <span className="font-medium" data-id="element-890">1</span> to{' '}
            <span className="font-medium" data-id="element-891">10</span> of{' '}
            <span className="font-medium" data-id="element-892">{products.length}</span> results
          </div>
          <div className="flex space-x-2" data-id="element-893">
            <button className="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 disabled:opacity-50" data-id="element-894">
              Previous
            </button>
            <button className="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 disabled:opacity-50" data-id="element-895">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>;
};